import React from 'react';

import { BaseIconProps } from './';

export const Info = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.109375,0,0,-2.109375,0,1080)"
    d="M 256,512 C 397,512 512,397 512,256 512,115 397,0 256,0 115,0 0,115 0,256 0,397 115,512 256,512 Z m 0,-384 c 18,0 32,14 32,32 v 96 c 0,18 -14,32 -32,32 -18,0 -32,-14 -32,-32 v -96 c 0,-18 14,-32 32,-32 z m 0,192 c 18,0 32,14 32,32 0,18 -14,32 -32,32 -18,0 -32,-14 -32,-32 0,-18 14,-32 32,-32 z"
    fill={fill}
  />
);
